export default __webpack_public_path__ + "static/media/pptLogo.4bc3cf11.svg";